import React, { Component } from "react";
import { Button, Paper } from "@material-ui/core";

import {
  getFirestoreDocument,
  updateFirestoreDocument,
  firebaseLogin,
  firebaseLogout,
  isFirebaseAuthenticated,
} from "../../firebase/firebase";

import { NotificationManager } from "react-notifications";
import Loader from "../../../../loader";


export default class SpecialProductsConfig extends Component {

  constructor(props) {
    super(props);

    this.state = {

      // ==========================================
      // GENERAL
      // ==========================================

      isLoaded: false,


      // ==========================================
      // FIREBASE AUTHENTICATION
      // ==========================================

      firebaseAuthenticated:
        isFirebaseAuthenticated(),

      firebaseAuthenticating:
        false,


      // ==========================================
      // SPECIAL PRODUCTS
      // ==========================================

      title: "",

      productIds: [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ],

      status: false,
    };
  }


  // =====================================================
  // COMPONENT DID MOUNT
  // =====================================================

  componentDidMount() {

    this.authenticateFirebase();
  }


  // =====================================================
  // AUTOMATIC FIREBASE AUTHENTICATION
  // =====================================================

  authenticateFirebase = async () => {

    // ==========================================
    // ALREADY AUTHENTICATED
    // ==========================================

    if (
      isFirebaseAuthenticated()
    ) {

      this.setState({
        firebaseAuthenticated:
          true,

        firebaseAuthenticating:
          false,
      });

      await this.loadSpecialProducts();

      return;
    }


    // ==========================================
    // SHOW AUTHENTICATING
    // ==========================================

    this.setState({
      firebaseAuthenticated:
        false,

      firebaseAuthenticating:
        true,
    });


    try {

      // ==========================================
      // AUTOMATIC LOGIN
      // ==========================================

      await firebaseLogin();


      // ==========================================
      // AUTHENTICATED
      // ==========================================

      this.setState({
        firebaseAuthenticated:
          true,

        firebaseAuthenticating:
          false,
      });


      // ==========================================
      // NOW LOAD CONFIGURATION
      // ==========================================

      await this.loadSpecialProducts();

    } catch (error) {

      console.error(
        "Firebase automatic authentication error:",
        error
      );


      firebaseLogout();


      this.setState({
        firebaseAuthenticated:
          false,

        firebaseAuthenticating:
          false,

        isLoaded:
          false,
      });


      NotificationManager.error(
        error &&
        error.message
          ? error.message
          : "Firebase authentication failed",
        "Authentication Error"
      );
    }
  };


  // =====================================================
  // LOAD SPECIAL PRODUCTS
  // =====================================================

  loadSpecialProducts = async () => {

    this.setState({
      isLoaded: true,
    });


    try {

      const data =
        await getFirestoreDocument(
          "special",
          "special"
        );


      const fields =
        data.fields || {};


      // ==========================================
      // PRODUCT IDS
      // ==========================================

      let productIds = [];


      if (
        fields.productid &&
        fields.productid.arrayValue &&
        fields.productid.arrayValue.values
      ) {

        productIds =
          fields.productid.arrayValue.values
            .map(
              (item) =>
                item.stringValue || ""
            )
            .slice(0, 8);
      }


      // ==========================================
      // ALWAYS SHOW 8 BOXES
      // ==========================================

      const eightProductIds = [
        ...productIds,

        ...Array(
          Math.max(
            0,
            8 - productIds.length
          )
        ).fill(""),
      ];


      this.setState({

        title:
          fields.title &&
          fields.title.stringValue
            ? fields.title.stringValue
            : "",


        productIds:
          eightProductIds,


        status:
          fields.status &&
          fields.status.booleanValue === true,


        isLoaded:
          false,
      });

    } catch (error) {

      console.error(
        "Error loading special products:",
        error
      );


      this.setState({
        isLoaded: false,
      });


      NotificationManager.error(
        "Unable to load special products",
        "Error"
      );
    }
  };


  // =====================================================
  // PRODUCT ID CHANGE
  // =====================================================

  handleProductIdChange = (
    index,
    value
  ) => {

    const numericValue =
      value.replace(
        /[^0-9]/g,
        ""
      );


    const productIds = [
      ...this.state.productIds,
    ];


    productIds[index] =
      numericValue;


    this.setState({
      productIds,
    });
  };


  // =====================================================
  // NORMAL FIELD CHANGE
  // =====================================================

  handleChange = (e) => {

    const {
      name,
      value,
    } = e.target;


    this.setState({

      [name]:
        name === "status"
          ? value === "true"
          : value,
    });
  };


  // =====================================================
  // BACK
  // =====================================================

  handleBack = () => {

    this.props.history.goBack();
  };


  // =====================================================
  // UPDATE SPECIAL PRODUCTS
  // =====================================================

  handleSubmit = async () => {

    // ==========================================
    // SECURITY CHECK
    // ==========================================

    if (
      !isFirebaseAuthenticated()
    ) {

      NotificationManager.error(
        "Firebase authentication has expired. Please reopen this page.",
        "Authentication Required"
      );


      this.setState({
        firebaseAuthenticated:
          false,
      });


      // Try authentication again.
      await this.authenticateFirebase();

      return;
    }


    const {
      title,
      productIds,
      status,
    } = this.state;


    // ==========================================
    // TITLE VALIDATION
    // ==========================================

    if (!title.trim()) {

      NotificationManager.error(
        "Special products title is required",
        "Input Error"
      );

      return;
    }


    // ==========================================
    // CLEAN PRODUCT IDS
    // ==========================================

    const cleanedProductIds =
      productIds
        .map(
          (id) =>
            id.trim()
        )
        .filter(
          (id) =>
            id !== ""
        );


    // ==========================================
    // MAXIMUM 8
    // ==========================================

    if (
      cleanedProductIds.length >
      8
    ) {

      NotificationManager.error(
        "Maximum 8 products are allowed",
        "Input Error"
      );

      return;
    }


    // ==========================================
    // DUPLICATES
    // ==========================================

    const uniqueProductIds =
      [
        ...new Set(
          cleanedProductIds
        ),
      ];


    if (
      uniqueProductIds.length !==
      cleanedProductIds.length
    ) {

      NotificationManager.error(
        "Duplicate product IDs are not allowed",
        "Duplicate Product ID"
      );

      return;
    }


    // ==========================================
    // LOADER
    // ==========================================

    this.setState({
      isLoaded: true,
    });


    try {

      // ==========================================
      // FIRESTORE ARRAY
      // ==========================================

      const productArray =
        cleanedProductIds.map(
          (id) => ({
            stringValue:
              id,
          })
        );


      // ==========================================
      // UPDATE
      // ==========================================

      await updateFirestoreDocument(
        "special",
        "special",
        {

          title: {
            stringValue:
              title.trim(),
          },


          productid: {
            arrayValue: {
              values:
                productArray,
            },
          },


          status: {
            booleanValue:
              status === true,
          },

        }
      );


      // ==========================================
      // SUCCESS
      // ==========================================

      this.setState({
        isLoaded: false,
      });


      NotificationManager.success(
        "Special products updated successfully",
        "Success"
      );


      // ==========================================
      // RELOAD
      // ==========================================

      await this.loadSpecialProducts();

    } catch (error) {

      console.error(
        "Error updating special products:",
        error
      );


      this.setState({
        isLoaded: false,
      });


      // ==========================================
      // PERMISSION ERROR
      // ==========================================

      const errorMessage =
        error &&
        error.message
          ? error.message
          : "";


      if (
        errorMessage.includes(
          "PERMISSION_DENIED"
        ) ||
        errorMessage.includes(
          "permission"
        ) ||
        errorMessage.includes(
          "UNAUTHENTICATED"
        )
      ) {

        firebaseLogout();


        this.setState({
          firebaseAuthenticated:
            false,
        });


        NotificationManager.error(
          "Firebase authentication expired or permission was denied.",
          "Permission Denied"
        );


        // ==========================================
        // AUTOMATIC RE-AUTHENTICATION
        // ==========================================

        await this.authenticateFirebase();


        return;
      }


      NotificationManager.error(
        errorMessage ||
          "Unable to update special products",
        "Error"
      );
    }
  };


  // =====================================================
  // RENDER
  // =====================================================

  render() {

    const {
      isLoaded,
      title,
      productIds,
      status,
      firebaseAuthenticated,
      firebaseAuthenticating,
    } = this.state;


    return (

      <div className="container-fluid">


        {/* ==========================================
            HEADER
        ========================================== */}

        <div className="row">

          <div className="col-lg-5 col-md-9">

            <h2 className="mt-30 page-title">
              Special Products
            </h2>

          </div>


          <div className="col-lg-5 col-md-3 back-btn">

            <Button
              variant="contained"
              onClick={
                this.handleBack
              }
            >

              <i className="fas fa-arrow-left" />

              {" "}

              Back

            </Button>

          </div>

        </div>


        {/* ==========================================
            BREADCRUMB
        ========================================== */}

        <ol className="breadcrumb mb-30">

          <li className="breadcrumb-item">
            Dashboard
          </li>

          <li className="breadcrumb-item">
            Special Products
          </li>

          <li className="breadcrumb-item active">
            Configuration
          </li>

        </ol>


        {/* ==========================================
            FORM
        ========================================== */}

        <Paper
          className="user-management"
          style={{
            padding:
              "1.5rem",

            marginBottom:
              "50px",
          }}
        >

          {isLoaded && (
            <Loader />
          )}


          {/* =====================================================
              AUTHENTICATION STATUS
          ===================================================== */}

          <div
            style={{

              marginBottom:
                "30px",

              padding:
                "20px",

              borderRadius:
                "10px",

              border:
                firebaseAuthenticated
                  ? "1px solid #28a745"
                  : "1px solid #dee2e6",

              background:
                firebaseAuthenticated
                  ? "#f0fff4"
                  : "#f8f9fa",

            }}
          >


            {/* ==========================================
                AUTH HEADER
            ========================================== */}

            <div
              style={{

                display:
                  "flex",

                alignItems:
                  "center",

                justifyContent:
                  "space-between",

                marginBottom:
                  "10px",

              }}
            >

              <div>

                <h5
                  style={{
                    margin:
                      0,

                    fontWeight:
                      "600",
                  }}
                >

                  Configuration
                  Authentication

                </h5>


                <small className="text-muted">

                  Firebase security authentication
                  is required before modifying
                  Special Products.

                </small>

              </div>


              {/* ==========================================
                  AUTHENTICATING
              ========================================== */}

              {firebaseAuthenticating && (

                <span
                  style={{

                    background:
                      "#ffc107",

                    color:
                      "#212529",

                    padding:
                      "7px 14px",

                    borderRadius:
                      "20px",

                    fontSize:
                      "12px",

                    fontWeight:
                      "600",

                  }}
                >

                  <i
                    className="fas fa-spinner fa-spin mr-1"
                  />

                  AUTHENTICATING

                </span>

              )}


              {/* ==========================================
                  AUTHENTICATED
              ========================================== */}

              {firebaseAuthenticated &&
                !firebaseAuthenticating && (

                <span
                  style={{

                    background:
                      "#28a745",

                    color:
                      "#fff",

                    padding:
                      "7px 14px",

                    borderRadius:
                      "20px",

                    fontSize:
                      "12px",

                    fontWeight:
                      "600",

                  }}
                >

                  <i
                    className="fas fa-check-circle mr-1"
                  />

                  AUTHENTICATED

                </span>

              )}

            </div>


            {/* ==========================================
                AUTHENTICATING MESSAGE
            ========================================== */}

            {firebaseAuthenticating && (

              <div
                style={{
                  marginTop:
                    "15px",
                }}
              >

                <small
                  className="text-muted"
                >

                  Verifying administrator
                  authentication...

                </small>

              </div>

            )}


            {/* ==========================================
                AUTHENTICATED MESSAGE
            ========================================== */}

            {firebaseAuthenticated &&
              !firebaseAuthenticating && (

              <div
                style={{
                  marginTop:
                    "15px",
                }}
              >

                <div
                  style={{
                    fontWeight:
                      "600",
                  }}
                >

                  <i
                    className="fas fa-shield-alt"
                    style={{
                      color:
                        "#28a745",

                      marginRight:
                        "8px",
                    }}
                  />

                  Authentication verified

                </div>


                <small className="text-muted">

                  You can now update the
                  Special Products configuration.

                </small>

              </div>

            )}

          </div>


          {/* =====================================================
              CONFIGURATION FORM
          ===================================================== */}

          <div
            style={{

              opacity:
                firebaseAuthenticated
                  ? 1
                  : 0.55,

              transition:
                "opacity 0.2s ease",

            }}
          >

            <div className="row">


              {/* ==========================================
                  TITLE
              ========================================== */}

              <div className="col-md-12 form-group">

                <label
                  style={{
                    fontWeight:
                      "600",
                  }}
                >

                  Special Products Title

                </label>


                <input
                  type="text"
                  className="form-control"
                  name="title"
                  value={title}
                  onChange={
                    this.handleChange
                  }
                  placeholder="Enter title"
                  disabled={
                    !firebaseAuthenticated
                  }
                />

              </div>


              {/* ==========================================
                  PRODUCT IDS
              ========================================== */}

              <div className="col-md-12 form-group">

                <label
                  style={{

                    fontWeight:
                      "600",

                    marginBottom:
                      "12px",

                  }}
                >

                  Special Product IDs

                </label>


                <div
                  style={{

                    background:
                      "#f8f9fa",

                    border:
                      "1px solid #e5e7eb",

                    borderRadius:
                      "10px",

                    padding:
                      "20px",

                  }}
                >

                  <div className="row">

                    {productIds.map(
                      (
                        productId,
                        index
                      ) => (

                        <div
                          className="col-lg-3 col-md-4 col-sm-6"
                          key={index}
                          style={{
                            marginBottom:
                              "18px",
                          }}
                        >

                          <label
                            style={{

                              fontSize:
                                "13px",

                              fontWeight:
                                "600",

                              color:
                                "#555",

                              marginBottom:
                                "6px",

                            }}
                          >

                            Product{" "}
                            {index + 1}

                          </label>


                          <div
                            style={{
                              position:
                                "relative",
                            }}
                          >

                            <span
                              style={{

                                position:
                                  "absolute",

                                left:
                                  "12px",

                                top:
                                  "50%",

                                transform:
                                  "translateY(-50%)",

                                fontWeight:
                                  "600",

                                color:
                                  "#999",

                                fontSize:
                                  "13px",

                                zIndex:
                                  1,

                              }}
                            >

                              #
                              {index + 1}

                            </span>


                            <input
                              type="text"
                              inputMode="numeric"
                              className="form-control"
                              value={
                                productId
                              }
                              onChange={
                                (e) =>
                                  this.handleProductIdChange(
                                    index,
                                    e.target.value
                                  )
                              }
                              placeholder="Product ID"
                              disabled={
                                !firebaseAuthenticated
                              }
                              style={{

                                paddingLeft:
                                  "42px",

                                height:
                                  "44px",

                                borderRadius:
                                  "7px",

                              }}
                            />

                          </div>

                        </div>

                      )
                    )}

                  </div>


                  <div
                    style={{

                      marginTop:
                        "4px",

                      paddingTop:
                        "12px",

                      borderTop:
                        "1px solid #e5e7eb",

                    }}
                  >

                    <small
                      style={{
                        color:
                          "#777",
                      }}
                    >

                      You can add up to
                      8 products.
                      Product IDs are
                      optional.
                      Empty boxes will
                      not be saved.
                      Duplicate IDs are
                      not allowed.

                    </small>

                  </div>

                </div>

              </div>


              {/* ==========================================
                  STATUS
              ========================================== */}

              <div className="col-md-6 form-group">

                <label
                  style={{
                    fontWeight:
                      "600",
                  }}
                >

                  Status

                </label>


                <select
                  className="form-control"
                  name="status"
                  value={String(status)}
                  onChange={
                    this.handleChange
                  }
                  disabled={
                    !firebaseAuthenticated
                  }
                  style={{

                    height:
                      "44px",

                    borderRadius:
                      "7px",

                  }}
                >

                  <option value="true">
                    Active
                  </option>

                  <option value="false">
                    Inactive
                  </option>

                </select>


                <small className="text-muted">

                  Active = Special
                  products enabled
                  {" | "}
                  Inactive = Special
                  products disabled

                </small>

              </div>

            </div>


            {/* ==========================================
                UPDATE BUTTON
            ========================================== */}

            <button
              type="button"
              className="btn btn-primary col-sm-3 mt-3 py-2"
              onClick={
                this.handleSubmit
              }
              disabled={
                isLoaded ||
                !firebaseAuthenticated ||
                firebaseAuthenticating
              }
            >

              <i className="fas fa-save mr-2" />

              Update Special Products

            </button>

          </div>

        </Paper>


        {/* ==========================================
            BOTTOM SPACING
        ========================================== */}

        <div
          style={{
            height:
              "60px",
          }}
        />

      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/admin/view/special/view/index.js